export const featuredPortfolio = [
  {
    id: "190eab69-8faf-4221-953e-5689d592d720",
    title: "Data Bandhi Chhod Public School — Creative Design",
    slug: "data-bandhi-chhod-public-school-creative-design",
    client: "Data Bandhi Chhod Public School",
    category: "Education & Social Media Design",
    summary:
      "Designed a wide range of digital and print creatives for Data Bandhi Chhod Public School, from admission campaigns and academic promotions to cultural occasions, recruitment and certificates. The work focused on maintaining a recognizable school identity while creating distinct visuals for different campaigns and audiences.",
    cover_image:
      "https://dorado9-com-897128.hostingersite.com/wp-content/uploads/2026/08/xsaxs.png",
    year: "2024 - 2026",
    services: [
      "Social Media Design",
      "Admission Campaign Creatives",
      "Graphic Design",
      "Print Design",
      "Promotional Design",
      "Certificate Design",
    ],
    metrics: [
      "Multi-Year Design Partnership",
      "Admission Campaign Creatives",
      "Print & Digital Design",
      "Multi-Format Brand Assets",
    ],
  },

  {
    id: "cfbe3d8e-2152-4a9a-82c7-098cbbc915f6",
    title: "Book Your Campus — Brand & Digital Design",
    slug: "book-your-campus-brand-digital-design",
    client: "Book Your Campus",
    category: "Brand & Digital Design",
    summary:
      "A collection of brand and communication materials designed for Book Your Campus, covering student admissions, academic guidance and institutional communication. The project involved creating a consistent visual language across handbooks, certificates, editorial layouts, promotional creatives and business documents while adapting each piece to its individual purpose.",
    cover_image:
      "https://dorado9-com-897128.hostingersite.com/wp-content/uploads/2026/08/ndf.png",
    year: "2026",
    services: [
      "Brand Collateral",
      "Editorial Design",
      "Graphic Design",
      "Print Design",
      "Social Media Design",
      "Document Design",
    ],
    metrics: [
      "50+ Brand Assets",
      "Multi-Format Design System",
      "Print & Digital Collateral",
      "Consistent Visual Identity",
    ],
  },

  {
    id: "d6d9568b-a6da-4d20-a147-a148a1a6191b",
    title: "Abacus Foundation Workbook",
    slug: "abacus-foundation-workbook",
    client: "Personagrow.com",
    category: "Graphic Designing",
    summary:
      "Designed a complete Abacus Foundation Workbook for young learners, turning lesson content and practice exercises into a structured, engaging learning experience. The project included page layouts, custom illustrations, activity pages, visual learning aids, and a consistent design system created for easy understanding and classroom use.",
    cover_image:
      "https://dorado9-com-897128.hostingersite.com/wp-content/uploads/2026/08/das.png",
    year: "2026",
    services: [
      "Adobe InDesign",
      "Workbook Design",
      "Editorial Design",
      "Educational Illustration",
      "Page Layout",
      "Print Design",
    ],
    metrics: [
      "100+ Pages Designed",
      "Custom Illustrations",
      "Print-Ready Layout",
      "Complete Workbook Design",
    ],
  },

  {
    id: "02f06a58-3ebc-46f7-87b5-23526af4efd4",
    title: "ProfitRains – Custom Trading Intelligence Platform",
    slug: "Profitrains",
    client: "Profitrains.com",
    category: "Finance",
    summary:
      "ProfitRains partnered with Dorado9 to design and develop a fully custom trading intelligence platform that delivers real-time market insights, trading tips, and premium educational content to its members. The objective was to create a high-performance mobile application that combines an intuitive user experience with powerful backend administration tools, enabling seamless communication between analysts and subscribers.\n\nFrom UI/UX design to backend architecture, every component was custom-built to provide a fast, secure, and scalable experience for both administrators and end users.",
    cover_image:
      "https://dorado9-com-897128.hostingersite.com/wp-content/uploads/2026/07/profit-scaled-e1785157122636.png",
    year: "2026",
    services: ["App Development"],
    metrics: [
      "15+ Core Features Developed",
      "5 Fully Customized App Modules",
      "10+ Admin Management Tools",
      "Real-Time Broadcast Messaging System",
      "Integrated Analytics & Reporting Dashboard",
      "Secure Cloud-Based Data Management",
    ],
  },
];